import React, { ChangeEvent } from 'react';
import { Button, Row, Col } from 'antd';
import { HasResource } from '../../../../../../components/HasResource';
import { ResourceCode } from 'constants/resourceCodes';
import InputFilterItem from "../../../../../delivery/components/InputFilterItem";
import ParcelFilterStyle from "../../../../../delivery/components/ParcelFilterStyle";
import DateRangeFilterItem from "../../../../../delivery/components/DateRangeFilterItem";
import { activeStatusOptions, timezoneOptions } from "./config/filterOptions";
import { PricingSchemeApplyFilterType } from '../graphql/types/PricingSchemeApplyType';
import type { SelectOptionType } from 'graphql/types/SelectOptionType';

interface DSPPricingApplyFilterProps {
    filters: PricingSchemeApplyFilterType;
    setFilters: (filters: PricingSchemeApplyFilterType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
    showBindDrawer: () => void;
    showUnBindDrawer: () => void;
    showBindEditDrawer: () => void;
    operatorOptions: SelectOptionType[];
    operatorOptionsLoading: boolean;
    dspBindValueOptions: SelectOptionType[];
    dspBindValueOptionsLoading: boolean;
}

const DSPPricingApplyFilter: React.FC<DSPPricingApplyFilterProps> = ({
    filters,
    setFilters,
    handleFilter,
    handleResetFilters,
    showBindDrawer,
    showUnBindDrawer,
    showBindEditDrawer,
    operatorOptions,
    operatorOptionsLoading,
    dspBindValueOptions,
    dspBindValueOptionsLoading
}) => {

    const handleBindTimeChange = (dates: [string | null, string | null] | null) => {
        setFilters({ ...filters, bindTime: dates });
    };

    const handleEffectiveTimeChange = (dates: [string | null, string | null] | null) => {
        setFilters({ ...filters, effectiveTime: dates });
    };

    return (
        <div className="mb-6">
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
                <InputFilterItem
                    label="方案ID"
                    value={filters.pricingSchemeId ?? undefined}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({
                        ...filters,
                        pricingSchemeId: e.target.value || undefined
                    })}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="操作人"
                    options={operatorOptions}
                    value={filters.operatorId ?? undefined}
                    onChange={(value: string) => setFilters({
                        ...filters,
                        operatorId: value || undefined
                    })}
                    disabled={operatorOptionsLoading}
                    spanClassName="w-[9em]"
                />

                <DateRangeFilterItem
                    label="操作绑定时间"
                    value={filters.bindTime}
                    onChange={handleBindTimeChange}
                    spanClassName="w-[9em]"
                />

                <DateRangeFilterItem
                    label="方案生效时间"
                    value={filters.effectiveTime}
                    onChange={handleEffectiveTimeChange}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="时区"
                    options={timezoneOptions}
                    value={filters.timezone ?? undefined}
                    onChange={(value: string) => setFilters({ ...filters, timezone: value ? value : undefined })}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="生效状态"
                    options={activeStatusOptions}
                    value={filters.activeStatus ?? undefined}
                    onChange={(value: string) => setFilters({ ...filters, activeStatus: value ? value : undefined })}
                    spanClassName="w-[9em]"
                />

                <ParcelFilterStyle
                    label="DSP客户维度"
                    options={dspBindValueOptions}
                    value={filters.bindValue ?? undefined}
                    onChange={(value: string) => setFilters({
                        ...filters,
                        bindValue: value || undefined
                    })}
                    disabled={dspBindValueOptionsLoading}
                    spanClassName="w-[9em]"
                />
            </div>
            <Row gutter={[8, 18]}>
                <Col span={24}>
                    <Row justify="end">
                        <Col>
                            <div className="flex gap-4">
                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_COST_PRICE_APPLY_OPERATE]}>
                                    <Button
                                        type="primary"
                                        onClick={showBindDrawer}
                                    >
                                        方案绑定
                                    </Button>
                                </HasResource>

                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_COST_PRICE_APPLY_OPERATE]}>
                                    <Button
                                        type="primary"
                                        onClick={showUnBindDrawer}
                                    >
                                        方案解绑
                                    </Button>
                                </HasResource>

                                <HasResource resourceCodes={[ResourceCode.settlement.SETTLEMENT_COST_PRICE_APPLY_OPERATE]}>
                                    <Button
                                        type="primary"
                                        onClick={showBindEditDrawer}
                                    >
                                        绑定编辑
                                    </Button>
                                </HasResource>

                                <Button
                                    type="primary"
                                    onClick={handleFilter}
                                >
                                    筛选
                                </Button>
                                <Button
                                    type="default"
                                    onClick={handleResetFilters}
                                >
                                    重置
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default DSPPricingApplyFilter;
